import { campusApiClient } from '@datacamp/campus-integration';
import { useEffect, useState } from 'react';
const getDownloadFilesLink = async (environment, courseId) => {
  const {
    datasets
  } = await campusApiClient(environment).getCourse(courseId);
  const filesDataset = datasets === null || datasets === void 0 ? void 0 : datasets.find(
  // @TODO ts: We'll need to adapt this code at some point...
  _ref => {
    let {
      name
    } = _ref;
    return name === 'Exercises and Datasets';
  });
  return filesDataset === null || filesDataset === void 0 ? void 0 : filesDataset.asset_url;
};
export const useDownloadFilesLink = (environment, courseId) => {
  const [downloadLink, setDownloadLink] = useState('#');
  useEffect(() => {
    getDownloadFilesLink(environment, courseId).then(link => {
      if (link) {
        setDownloadLink(link);
      }
    });
  }, [courseId, environment]);
  return downloadLink;
};